import { render, staticRenderFns } from "./isPro2.vue?vue&type=template&id=6a58b815&scoped=true&"
import script from "./isPro2.vue?vue&type=script&lang=js&"
export * from "./isPro2.vue?vue&type=script&lang=js&"
import style0 from "./isPro2.vue?vue&type=style&index=0&id=6a58b815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58b815",
  null
  
)

export default component.exports